// @ts-check
import React, { createContext, useState } from "react"
import usePrevious from "../../../hooks/usePrevious"
import {getModifiedDateTime} from "../../../utils/dateTime.utils"

/** @typedef {import("./TimeRegister.context.types.d.ts").context} context */

/** @type {React.Context<context>} */
// @ts-ignore (This will always have an initial value.)
export const TimeRegisterContext = createContext()

export default function TimeRegisterContextProvider({ children }) {
  const [refreshProjects, setRefreshProjects] = useState(false)
  const [doFetchTasks, setDoFetchTasks] = useState(false)
  const [isDayFinished, setIsDayFinished] = useState(false)
  const [isDayEditable, setIsDayEditable] = useState(true)
  const [isEditingSisuTime, setIsEditingSisuTime] = useState(false)
  const [isEditingBilledTime, setIsEditingBilledTime] = useState(false)
  const [showMissingDayDialog, setShowMissingDayDialog] = useState(false)
  const [showedMissingDayDialog, setShowedMissingDayDialog] = useState(false)
  const [showUncompleteDayDialog, setShowUncompleteDayDialog] = useState(false)
  const [showedUncompleteDayDialog, setShowedUncompleteDayDialog] = useState(false)
  const [showVacationDayDialog, setShowVacationDayDialog] = useState(false)
  const [showedVacationDayDialog, setShowedVacationDayDialog] = useState(false)
  const [selectedDate, setSelectedDate] = useState(getModifiedDateTime({atNoon: true}).toJSDate())
  const previousSelectedDate = usePrevious(selectedDate)
  const [daysOff, setDaysOff] = useState([])
  const [uncompleteDay, setUncompleteDay] = useState(null)
  const [lastWorkDay, setLastWorkDay] = useState(null)
  const [workDayToDisplay, setWorkDayToDisplay] = useState(null)
  const [hasTasks, setHasTasks] = useState(false)
  const [canSaveChanges, setCanSaveChanges] = useState(false)
  const [triggerFinishDay, setTriggerFinishDay] = useState(false)
  const [loading, setLoading] = useState(false)
  const [editingMissingDay, setEditingMissingDay] = useState(false)
  const setRefresh = () => setDoFetchTasks(!doFetchTasks)

  return (
    <TimeRegisterContext.Provider
      value={{
        refreshProjects,
        setRefreshProjects,
        doFetchTasks,
        setDoFetchTasks,
        isDayFinished,
        setIsDayFinished,
        isDayEditable,
        setIsDayEditable,
        isEditingSisuTime,
        setIsEditingSisuTime,
        isEditingBilledTime,
        setIsEditingBilledTime,
        showUncompleteDayDialog,
        setShowUncompleteDayDialog,
        showMissingDayDialog,
        setShowMissingDayDialog,
        showedUncompleteDayDialog,
        setShowedUncompleteDayDialog,
        showedMissingDayDialog,
        setShowedMissingDayDialog,
        selectedDate,
        setSelectedDate,
        daysOff,
        // @ts-ignore
        setDaysOff,
        showVacationDayDialog,
        setShowVacationDayDialog,
        showedVacationDayDialog,
        setShowedVacationDayDialog,
        uncompleteDay,
        // @ts-ignore
        setUncompleteDay,
        lastWorkDay,
        // @ts-ignore
        setLastWorkDay,
        hasTasks,
        setHasTasks,
        canSaveChanges,
        setCanSaveChanges,
        triggerFinishDay,
        setTriggerFinishDay,
        loading,
        setLoading,
        // @ts-ignore
        previousSelectedDate,
        setRefresh,
        editingMissingDay,
        setEditingMissingDay,
        workDayToDisplay,
        // @ts-ignore
        setWorkDayToDisplay,
      }}
    >
      {children}
    </TimeRegisterContext.Provider>
  )
}
